import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Container, Typography, Stack, Button } from '@mui/material';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { UserListToolbar } from '../sections/@dashboard/user';

import Iconify from '../components/iconify';

// api
import { getGenericData } from './api';
import ModalAddCentroCusto from './ModalAddCentroCusto';

// ----------------------------

const emptyData = { nome: '', ativo: true };

// ----------------------------------------------------------------------

export default function CentrosCustos() {
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [dataSelected, setDataSelected] = useState({ ...emptyData });
  const [filterValue, setFilterValue] = useState('');

  const fetchData = async () => {
    const result = await getGenericData('centrocusto', {});
    setData(result);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const filtered = data.filter((row) => {
    const filterValueLower = filterValue.toLowerCase();
    return row.nome?.toLowerCase().includes(filterValueLower);
  });

  const handleFilter = (event) => {
    setFilterValue(event.target.value);
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setDataSelected({ ...emptyData });
  };

  const onConfirmHandler = async () => {
    fetchData();
    handleClose();
  };

  const handleDoubleClickTable = (row, index) => {
    setDataSelected({ ...row, index });
    setOpen(true);
  };

  return (
    <>
      <Helmet>
        <title> Centros de Custo </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Centros de Custo
          </Typography>

          <Stack direction={'row'} gap={2}>
            <Button
              variant="contained"
              startIcon={<Iconify icon="zondicons:add-solid" />}
              onClick={handleOpen}
              sx={{ height: 50, minWidth: 100 }}
            >
              Adicionar
            </Button>
          </Stack>
        </Stack>

        <UserListToolbar filterName={filterValue} onFilterName={handleFilter} sx={{ width: '80vw' }} />

        {/* ------------ Tabela de Kits ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Nome</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: 'Azure' } }}
                  onDoubleClick={() => handleDoubleClickTable(row, index)}
                >
                  <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                    {row.nome}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Modal Add */}
        {open && (
          <ModalAddCentroCusto
            open={open}
            dataSelected={dataSelected}
            onClose={handleClose}
            onConfirm={onConfirmHandler}
          />
        )}
      </Container>
    </>
  );
}
